import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_libplugin54fd88d8_73979779 from 'nuxt_plugin_libplugin54fd88d8_73979779' // Source: ./lib.plugin.54fd88d8.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_moment_42881812 from 'nuxt_plugin_moment_42881812' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_pianoanalyticsclient_698da7ae from 'nuxt_plugin_pianoanalyticsclient_698da7ae' // Source: ./piano-analytics/piano-analytics.client.js (mode: 'client')
import nuxt_plugin_pianoanalytics_3c9a7e27 from 'nuxt_plugin_pianoanalytics_3c9a7e27' // Source: ./piano-analytics/piano-analytics.js (mode: 'all')
import nuxt_plugin_map_16e92944 from 'nuxt_plugin_map_16e92944' // Source: ./mapper/map.js (mode: 'all')
import nuxt_plugin_log_7ec2cca3 from 'nuxt_plugin_log_7ec2cca3' // Source: ./log/log.js (mode: 'all')
import nuxt_plugin_logclient_51b9549c from 'nuxt_plugin_logclient_51b9549c' // Source: ./log/log.client.js (mode: 'client')
import nuxt_plugin_logserver_3cdcc73a from 'nuxt_plugin_logserver_3cdcc73a' // Source: ./log/log.server.js (mode: 'server')
import nuxt_plugin_eoapiprivateclient_f22b3f84 from 'nuxt_plugin_eoapiprivateclient_f22b3f84' // Source: ./eo-api/eo-api-private.client.js (mode: 'client')
import nuxt_plugin_eoapiprivateserver_26b85c74 from 'nuxt_plugin_eoapiprivateserver_26b85c74' // Source: ./eo-api/eo-api-private.server.js (mode: 'server')
import nuxt_plugin_eoapi_dc67ebe6 from 'nuxt_plugin_eoapi_dc67ebe6' // Source: ./eo-api/eo-api.js (mode: 'all')
import nuxt_plugin_cookieconsentclient_3dbbd3c8 from 'nuxt_plugin_cookieconsentclient_3dbbd3c8' // Source: ./cookie-consent/cookie-consent.client.js (mode: 'client')
import nuxt_plugin_cookieconsent_b9934966 from 'nuxt_plugin_cookieconsent_b9934966' // Source: ./cookie-consent/cookie-consent.js (mode: 'all')
import nuxt_plugin_preprcaptureclient_077b571a from 'nuxt_plugin_preprcaptureclient_077b571a' // Source: ./preprcapture/prepr-capture.client.js (mode: 'client')
import nuxt_plugin_componentlibrary_ef3788d6 from 'nuxt_plugin_componentlibrary_ef3788d6' // Source: ./component-library/component-library.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Over","titleTemplate":"%s - EO","__dangerouslyDisableSanitizers":["script"],"htmlAttrs":{"lang":"nl"},"meta":[{"name":"app-version","content":"v1.167.6"}],"script":[{"innerHTML":"\n          \u003C!-- Start VWO Async SmartCode --\u003E\n          window._vwo_code = window._vwo_code || (function(){\n          var account_id=293093,\n          settings_tolerance=3000,\n          library_tolerance=3500,\n          use_existing_jquery=false,\n          is_spa=1,\n          hide_element='body',\n\n          \u002F* DO NOT EDIT BELOW THIS LINE *\u002F\n          f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text\u002Fjavascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){\n          window.settings_timer=setTimeout('_vwo_code.finish()',settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text\u002Fcss');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https:\u002F\u002Fdev.visualwebsiteoptimizer.com\u002Fj.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());\n          \u003C!-- End VWO Async SmartCode --\u003E\n        ","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"preprcapture-script","innerHTML":"\n    ! function (e, t, p, r, n, a, s) {\n        e[r] || ((n = e[r] = function () {\n            n.process ? n.process.apply(n, arguments) : n.queue.push(arguments)\n        }).queue = [], n.t = +new Date, (a = t.createElement(p)).async = 1, a.src = \"https:\u002F\u002Fanalytics.eo.nl\u002Fjs\u002Fprepr.min.js?t=\" + 864e5 * Math.ceil(new Date \u002F 864e5), (s = t.getElementsByTagName(p)[0]).parentNode.insertBefore(a, s))\n    }(window, document, \"script\", \"prepr\"), prepr(\"init\", \"e942c3ac8072ceaa1208872391520f957920f7647fc26f1b51e025d58adfaf1a\");\n  "},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fload.sst.eo.nl\u002Fljpkmfzp.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KKB5RFJ')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fload.sst.eo.nl\u002Fns.html?id=GTM-KKB5RFJ&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin54fd88d8_73979779 === 'function') {
    await nuxt_plugin_libplugin54fd88d8_73979779(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_42881812 === 'function') {
    await nuxt_plugin_moment_42881812(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pianoanalyticsclient_698da7ae === 'function') {
    await nuxt_plugin_pianoanalyticsclient_698da7ae(app.context, inject)
  }

  if (typeof nuxt_plugin_pianoanalytics_3c9a7e27 === 'function') {
    await nuxt_plugin_pianoanalytics_3c9a7e27(app.context, inject)
  }

  if (typeof nuxt_plugin_map_16e92944 === 'function') {
    await nuxt_plugin_map_16e92944(app.context, inject)
  }

  if (typeof nuxt_plugin_log_7ec2cca3 === 'function') {
    await nuxt_plugin_log_7ec2cca3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_logclient_51b9549c === 'function') {
    await nuxt_plugin_logclient_51b9549c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_logserver_3cdcc73a === 'function') {
    await nuxt_plugin_logserver_3cdcc73a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eoapiprivateclient_f22b3f84 === 'function') {
    await nuxt_plugin_eoapiprivateclient_f22b3f84(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_eoapiprivateserver_26b85c74 === 'function') {
    await nuxt_plugin_eoapiprivateserver_26b85c74(app.context, inject)
  }

  if (typeof nuxt_plugin_eoapi_dc67ebe6 === 'function') {
    await nuxt_plugin_eoapi_dc67ebe6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieconsentclient_3dbbd3c8 === 'function') {
    await nuxt_plugin_cookieconsentclient_3dbbd3c8(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieconsent_b9934966 === 'function') {
    await nuxt_plugin_cookieconsent_b9934966(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_preprcaptureclient_077b571a === 'function') {
    await nuxt_plugin_preprcaptureclient_077b571a(app.context, inject)
  }

  if (typeof nuxt_plugin_componentlibrary_ef3788d6 === 'function') {
    await nuxt_plugin_componentlibrary_ef3788d6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
